import { Button } from "@mui/material";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import { useState } from "react";
import {
  postMoveToChapterRefrences,
  postMoveToPreviousChapter,
  postMoveToPreviousTest,
  postReturnFromToilet,
  postReturnToChapterStart
} from "../../Operator/OperatorAPI/OperatorPost";

const UserReturnDialog = ({ onClose, user }) => {
  const [skipType, setReturnType] = useState("");
  const handleReturnTest = userId => {
    postMoveToPreviousTest(userId);
  };

  const handleReturnChapter = userId => {
    postMoveToPreviousChapter(userId);
  };

  const handleReturnToRefrences = userId => {
    postMoveToChapterRefrences(userId);
  };

  // Restarts the chapter they're already in, rather than dropping back a chapter.
  const handleReturnToChapterStart = userId => {
    postReturnToChapterStart(userId);
  };

  const handleReturnFromToilet = userId => {
    postReturnFromToilet(userId);
  };

  const handleReturnTypeSelect = (type, user) => {
    setReturnType(type);
    if (type === "test") {
      handleReturnTest(user.id);
    } else if (type === "chapter") {
      handleReturnChapter(user.id);
    } else if (type === "refrences") {
      handleReturnToRefrences(user.id);
    } else if (type === "chapterStart") {
      handleReturnToChapterStart(user.id);
    } else if (type === "toilet") {
      handleReturnFromToilet(user.id);
    }
    onClose();
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>{`Return ${user?.name}`}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to Return {user?.name}?
        </DialogContentText>
        <DialogContentText variant="caption" dir="rtl" sx={{ mt: 1 }}>
          הנבחן יועבר מיד ותוצג לו הודעה על כך.
        </DialogContentText>
        <DialogContentText variant="caption" dir="rtl" sx={{ mt: 1 }}>
          "Return To Chapter Start" מחזיר לתחילת הפרק הנוכחי (ולא לפרק הקודם), ומוודא
          שנותרו לנבחן לפחות שתי דקות בפרק.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => handleReturnTypeSelect("toilet", user)}
          color="primary"
        >
          Return From Toilet
        </Button>
        <Button
          onClick={() => handleReturnTypeSelect("refrences", user)}
          color="primary"
        >
          Return To Refrences
        </Button>
        <Button
          onClick={() => handleReturnTypeSelect("test", user)}
          color="primary"
        >
          Return Test
        </Button>
        <Button
          onClick={() => handleReturnTypeSelect("chapter", user)}
          color="primary"
        >
          Return Chapter
        </Button>
        <Button
          onClick={() => handleReturnTypeSelect("chapterStart", user)}
          color="warning"
          variant="outlined"
        >
          Return To Chapter Start
        </Button>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default UserReturnDialog;
